import app from '../app';

export const CADASTRAL_NUMBER_REGEXP = /[^\d:]+/gi;

app.directive('cianAfCadastralNumber', () => {
  return {
    priority: 1,
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attrs, ngModel) => {
      const keepCadastralNumber = rawNumber => {
        const number = String(rawNumber);

        const cleanNumber = (number || '').replace(CADASTRAL_NUMBER_REGEXP, '');

        if (cleanNumber !== number) {
          ngModel.$setViewValue(cleanNumber);
          element.val(cleanNumber);
        }

        return cleanNumber;
      };

      ngModel.$parsers.unshift(keepCadastralNumber);
    },
  };
});
